import { ApplyData, studyCenterService } from "@services/study-center";

import { useMutation } from "react-query";

export const useApplyForEducationalPromotionMutation = () => {
  return useMutation((data: ApplyData) =>
    studyCenterService.applyForPromotion(data)
  );
};
